import type { CSSObject } from "type/tss";
import { designTokens } from "theme";

export const styles = () => ({
	// Card-style accordion per Figma (989:13617): 8px rounded corners, 1px border-card outline,
	// separated by a gap, no MUI default divider/elevation.
	accordion: {
		border: `1px solid ${designTokens.colors.borderCard}`,
		borderRadius: 8,
		marginBottom: 12,
		boxShadow: "none",
		overflow: "hidden", // keep the summary hover/expanded fill inside the rounded corners
		// MUI draws a top divider line between stacked accordions — remove it.
		"&:before": { display: "none" },
		// MUI zeroes the margin when expanded — preserve the separation gap.
		"&.Mui-expanded": { margin: "0 0 12px 0" },
		"&:last-child": { marginBottom: 0 },
	},
	// Lets content (the campaigns table + its gray header band) span the full card width.
	detailsNoPadding: {
		padding: 0,
	},
} satisfies Record<string, CSSObject>);
